import { BadgeCheck, ShieldCheck, FileBadge } from "lucide-react";

const CERTS = [
  {
    icon: BadgeCheck,
    code: "ISO 13485:2016",
    label: "Medical Device Quality Management",
    body: "Certified by Shanghai POSI Certification Co., Ltd. for sourcing and supply of medical devices.",
  },
  {
    icon: ShieldCheck,
    code: "CE Marking",
    label: "European Conformity — Class I Medical Devices",
    body: "Verified by SUNGO Cert GmbH per EU Medical Device Directive 93/42/EEC.",
  },
  {
    icon: FileBadge,
    code: "Licensed & Registered",
    label: "Authorised for International Trade",
    body: "Registered under Yiwu City authorities for cross-border export and sourcing operations.",
  },
];

export default function Certifications() {
  return (
    <section
      data-testid="certifications-section"
      className="relative bg-ink-50 py-20 md:py-24 border-y border-ink-100"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-10 md:mb-14">
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-signal mb-4">
              Compliance & trust
            </p>
            <h2 className="font-heading font-black text-ink-900 tracking-[-0.02em] leading-[1.05] text-3xl md:text-4xl lg:text-5xl">
              Certified, audited,<br />
              shipping-grade.
            </h2>
          </div>
          <p className="max-w-md text-ink-500 text-[15px] leading-relaxed">
            For our medical and dental clients, paperwork isn't a courtesy — it's
            the contract. Every shipment ships against documented standards.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {CERTS.map((c) => {
            const Icon = c.icon;
            return (
              <article
                key={c.code}
                data-testid={`cert-${c.code.replace(/[^a-z0-9]/gi, "-").toLowerCase()}`}
                className="bg-white border border-ink-100 p-7 md:p-8 hover:border-ink-900 transition-colors"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-ink-900 text-white">
                  <Icon className="w-5 h-5" strokeWidth={1.6} />
                </div>
                <div className="mt-6 font-mono text-[11px] uppercase tracking-[0.22em] text-signal">
                  {c.code}
                </div>
                <h3 className="mt-2 font-heading font-bold text-lg md:text-xl tracking-tight text-ink-900">
                  {c.label}
                </h3>
                <p className="mt-3 text-ink-500 text-[14px] leading-relaxed">{c.body}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
